<template>
  <div class="ac-page">
    <div class="ac-body center-top">
      <div class="success-mark">
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
          <path
            d="M7 17.5l6.5 6.5L27 10"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <h1 class="success-title">{{ isExisting ? "账号注销审核中" : "注销申请提交成功" }}</h1>
      <p class="success-sub">{{ isExisting ? "你的注销申请正在处理中" : "感谢您对我们游戏的支持" }}</p>

      <div class="success-card">
        <p>
          亲爱的玩家，你的账号 <b>{{ maskedTel }}</b> 于 {{ result.applyTime }} 申请注销，已完成条件审核。除法律法规规定和注销协议约定情形外，我们将在你提交申请之日起的 {{ auditDays }} 日内完成注销。
        </p>
        <p class="warn">
          在上述 {{ auditDays }} 日届满前，即 {{ result.expireTime }} 前，请你不要登录账号 / 游戏，以便注销顺利完成，否则视为你撤销账号注销申请。
        </p>
      </div>
    </div>

    <div class="ac-footer">
      <button class="ac-btn is-primary" @click="onKnow">我知道了</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { COOLING_DAYS } from "./config";

export default {
  name: "AccountCancelSuccess",
  created() {
    if (!this.$store.state.accountCancel.closeToken) {
      this.$router.replace({ name: "gameJump-accountCancelLogin" });
    }
  },
  computed: {
    ...mapState("accountCancel", {
      result: "result",
      telNum: "telNum",
      telMasked: "telMasked",
      form: "form",
    }),
    // 由登录态进入（已有审核中的申请），而非刚提交成功
    isExisting() {
      return !!this.$route.query.existing;
    },
    // 审核天数：优先用接口返回，兜底用配置常量
    auditDays() {
      return this.result.auditDays || COOLING_DAYS;
    },
    // 优先展示脱敏手机号；未绑定手机号（如账密登录）时回退展示账号名
    maskedTel() {
      if (this.telMasked) return this.telMasked;
      const t = this.telNum || "";
      if (t.length === 11) return `${t.slice(0, 3)}****${t.slice(7)}`;
      return t || this.form.userName || "";
    },
  },
  methods: {
    onKnow() {
      // 回到登录页（登录页 created 会清空用户信息，避免离开前清空导致空页闪现）
      this.$router.replace({ name: "gameJump-accountCancelLogin" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";

.center-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 36px;
  text-align: center;
}

.success-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: $ac-brand-grad;
  color: #fff;
}

.success-title {
  margin-top: 20px;
  font-size: 22px;
  font-weight: 700;
}

.success-sub {
  margin-top: 8px;
  color: $ac-sub;
  font-size: 14px;
}

.success-card {
  margin-top: 28px;
  padding: 20px 18px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(20, 25, 35, 0.05);
  text-align: left;

  p {
    color: #3a3f4a;
    font-size: 14px;
    line-height: 1.8;

    b {
      color: $ac-text;
    }
  }

  .warn {
    margin-top: 14px;
    color: $ac-brand;
  }
}
</style>
